<template>
<quill-editor :content="content"
              :options="options"
              @change="onEditorChange($event)"
              >
</quill-editor>
</template>

<script>
import ImageResize from 'quill-image-resize-module';
import Quill from 'quill';

import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';

Quill.register('modules/imageResize', ImageResize);
const quillFontSize = Quill.import('attributors/style/size');
quillFontSize.whitelist = ['14px', '16px', '20px', '32px'];
Quill.register(quillFontSize, true);

export default {
  props: ['content', 'options'],
  components: {
    quillEditor,
  },
  methods: {
    onEditorChange({ html }) {
      this.$emit('update:content', html);
    },
  },
};
</script>

<style scoped>
.quillEditor {
    height: 15em;
}
</style>

<style>
/*
 * https://stackoverflow.com/a/43808486
 */
.ql-picker.ql-size .ql-picker-item[data-value="14px"]::before {
  content: 'Small' !important;
  font-size: 14px !important;
}

.ql-picker.ql-size .ql-picker-item[data-value="16px"]::before {
  content: 'Normal' !important;
  font-size: 16px !important;
}

.ql-picker.ql-size .ql-picker-item[data-value="20px"]::before {
  content: 'Large' !important;
  font-size: 20px !important;
}

.ql-picker.ql-size .ql-picker-item[data-value="32px"]::before {
  content: 'Huge' !important;
  font-size: 32px !important;
}

.ql-picker-label[data-value="14px"]::before {
  content: 'Small' !important;
}

.ql-picker-label[data-value="16px"]::before {
  content: 'Normal' !important;
}

.ql-picker-label[data-value="20px"]::before {
  content: 'Large' !important;
}

.ql-picker-label[data-value="32px"]::before {
  content: 'Huge' !important;
}
</style>



// WEBPACK FOOTER //
// src/components/QuillEditor.vue